import { SVGProps, Ref, forwardRef, useId } from 'react';

export const EmojiSmile3dSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => {
    const _uniqueId = useId();
    return (
        <svg
            width={32}
            height={32}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g filter={`url(#${_uniqueId}filter0_i_8745_100)`} suppressHydrationWarning>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.854 19.586a2.45 2.45 0 0 1 1.813-.786h10.667c.69 0 1.356.284 1.812.786a2.12 2.12 0 0 1 .462 2.088 6.15 6.15 0 0 1-1.4 2.347c-1.466 1.563-3.732 2.512-6.208 2.512s-4.742-.95-6.209-2.512a6.15 6.15 0 0 1-1.398-2.347 2.12 2.12 0 0 1 .46-2.088m2.687 2.793a3.9 3.9 0 0 1-.77-1.179H21.23a3.9 3.9 0 0 1-.77 1.179c-.965 1.028-2.573 1.754-4.459 1.754s-3.493-.726-4.459-1.754"
                    fill={`url(#${_uniqueId}paint0_radial_8745_100)`}
                    suppressHydrationWarning
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.334 16C1.334 3.167 3.167 1.333 16 1.333S30.667 3.167 30.667 16 28.833 30.667 16 30.667 1.334 28.833 1.334 16m7.52 3.586a2.45 2.45 0 0 1 1.813-.786h10.667c.69 0 1.356.284 1.812.786a2.12 2.12 0 0 1 .462 2.088 6.15 6.15 0 0 1-1.4 2.347c-1.466 1.563-3.732 2.512-6.208 2.512s-4.742-.95-6.209-2.512a6.15 6.15 0 0 1-1.398-2.347 2.12 2.12 0 0 1 .46-2.088m11.813-9.253c-1.75 0-2.334 1.167-2.334 2.334 0 1.166.584 2.333 2.334 2.333S23 13.833 23 12.667s-.583-2.334-2.333-2.334M9 12.667c0-1.167.584-2.334 2.334-2.334s2.333 1.167 2.333 2.334c0 1.166-.583 2.333-2.333 2.333S9 13.833 9 12.667"
                    fill={`url(#${_uniqueId}paint1_radial_8745_100)`}
                    suppressHydrationWarning
                />
                <path
                    d="M10.771 21.2c.17.415.427.814.77 1.179.966 1.028 2.573 1.754 4.46 1.754 1.885 0 3.492-.726 4.458-1.754.343-.365.601-.764.77-1.179z"
                    fill={`url(#${_uniqueId}paint2_radial_8745_100)`}
                    suppressHydrationWarning
                />
                <path
                    d="M20.667 10.333c-1.75 0-2.334 1.167-2.334 2.334 0 1.166.584 2.333 2.334 2.333S23 13.833 23 12.667s-.583-2.334-2.333-2.334"
                    fill={`url(#${_uniqueId}paint3_radial_8745_100)`}
                    suppressHydrationWarning
                />
                <path
                    d="M9 12.667c0-1.167.584-2.334 2.334-2.334s2.333 1.167 2.333 2.334c0 1.166-.583 2.333-2.333 2.333S9 13.833 9 12.667"
                    fill={`url(#${_uniqueId}paint4_radial_8745_100)`}
                    suppressHydrationWarning
                />
            </g>
            <path
                d="M20.667 10.333c-1.75 0-2.334 1.167-2.334 2.334 0 1.166.584 2.333 2.334 2.333S23 13.833 23 12.667s-.583-2.334-2.333-2.334"
                fill="#9E7F10"
            />
            <path
                d="M9 12.667c0-1.167.583-2.334 2.333-2.334s2.334 1.167 2.334 2.334c0 1.166-.584 2.333-2.334 2.333S9 13.833 9 12.667"
                fill="#9E7F10"
            />
            <path
                d="M10.667 18.8c-.69 0-1.357.284-1.813.786a2.12 2.12 0 0 0-.461 2.088 6.15 6.15 0 0 0 1.399 2.347c1.467 1.563 3.732 2.512 6.208 2.512s4.742-.95 6.209-2.512a6.15 6.15 0 0 0 1.399-2.347 2.12 2.12 0 0 0-.462-2.088 2.45 2.45 0 0 0-1.812-.786z"
                fill="#9E7F10"
            />
            <path
                d="M10.667 18.8c-.69 0-1.357.284-1.813.786a2.12 2.12 0 0 0-.461 2.088 6.15 6.15 0 0 0 1.399 2.347c1.467 1.563 3.732 2.512 6.208 2.512s4.742-.95 6.209-2.512a6.15 6.15 0 0 0 1.399-2.347 2.12 2.12 0 0 0-.462-2.088 2.45 2.45 0 0 0-1.812-.786z"
                fill="#9E7F10"
            />
            <path d="M16 22c-3.047 0-6.667-.667-7.334-2.667h14.667C22.667 21.333 19.047 22 16 22" fill="white" />
            <path
                d="M16 24c-2.216 0-4.849.333-5.334 1.333L16 26l5.333-.667C20.848 24.333 18.216 24 16 24"
                fill="white"
            />
            <path
                d="M10.667 18.8c-.69 0-1.357.284-1.813.786a2.12 2.12 0 0 0-.461 2.088 6.15 6.15 0 0 0 1.399 2.347c1.467 1.563 3.732 2.512 6.208 2.512s4.742-.95 6.209-2.512a6.15 6.15 0 0 0 1.399-2.347 2.12 2.12 0 0 0-.462-2.088 2.45 2.45 0 0 0-1.812-.786z"
                stroke="#79610C"
                strokeWidth={1.333}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <defs>
                <filter
                    id={`${_uniqueId}filter0_i_8745_100`}
                    x={1.333}
                    y={-3.667}
                    width={34.333}
                    height={34.333}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                    suppressHydrationWarning
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx={5} dy={-5} />
                    <feGaussianBlur stdDeviation={5} />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_8745_100" />
                </filter>
                <radialGradient
                    id={`${_uniqueId}paint0_radial_8745_100`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(22.2794 6.83325) rotate(127.875) scale(26.129)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint1_radial_8745_100`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(22.2794 6.83325) rotate(127.875) scale(26.129)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint2_radial_8745_100`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(22.2794 6.83325) rotate(127.875) scale(26.129)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint3_radial_8745_100`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(22.2794 6.83325) rotate(127.875) scale(26.129)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint4_radial_8745_100`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(22.2794 6.83325) rotate(127.875) scale(26.129)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
            </defs>
        </svg>
    );
});
EmojiSmile3dSize32Glyph.displayName = 'EmojiSmile3dSize32Glyph';
